
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import PlayerNavigationVue from "@/components/player/navigation.vue";
import PlayerResourcesNavigationVue from "@/components/player/resources/navigation.vue";
import AppPlayerResourcesRootExercisesIndexVue from "@/views/app/player/resources/root/exercises/index.vue";
import AppPlayerResourcesRootDietsIndexVue from "@/views/app/player/resources/root/diets/index.vue";
import AppPlayerResourcesRootSupplementsIndexVue from "@/views/app/player/resources/root/supplements/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    PlayerNavigationVue,
    PlayerResourcesNavigationVue,
    AppPlayerResourcesRootExercisesIndexVue,
    AppPlayerResourcesRootDietsIndexVue,
    AppPlayerResourcesRootSupplementsIndexVue,
  },
})
export default class AppPlayerResourcesRootIndexVue extends Vue {}
